module.exports = __webpack_public_path__ + "img/darkana_fight.65446b45.jpg";